module.exports = __webpack_public_path__ + "img/layout.15ea5701.svg";